import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import { palette } from 'configurations/styles/theme';

const ModulesBtn = () => {
    const navigate = useNavigate();

    return (
        <Tooltip title={`Módulos`}>
            <IconButton onClick={() => navigate("/modulos")}>
                <HomeOutlinedIcon style={{ color: palette.primary.menuHeader }} />
            </IconButton>
        </Tooltip>
    );
}

export default ModulesBtn;
